import { Mobile } from '../core'

const INITIAL_MAX_HEIGHT = 100

export default {

  init() {
    $.mlmi = {
      mobile: new Mobile(),
    }

    /* Top bar */
    const getTopBarHeight = function() {
      let topBarHeight = 0
      if ($('.top-bar .featured-message__container').length) {
        topBarHeight = $('.top-bar .featured-message__container').outerHeight()
      }
      $('body').css('--top-bar-height', topBarHeight + 'px');
      $('body').addClass('--top-bar-ready');
    }
    $(window).on('load resize orientationchange', getTopBarHeight)
    getTopBarHeight()

    $('.top-bar .featured-message__close').click(function() {
      $('body').css('--top-bar-height', '0px');
    });

    //Add quick links to all submenus
    $('.main-menu__sub-menu--1').each(function() {
      $(this).wrap( "<div class='js-sub-menu-wrapper'><div class='js-sub-menu'></div></div>" );
      $('.header__main-menu .header__quick-links').first().clone().addClass('desktop-only').insertAfter($(this));
      $('.header__main-menu .header__contact').first().clone().addClass('desktop-only').insertAfter($(this));
      $('.header__main-menu .js-close-main-menu').first().clone().insertAfter($(this));
      $(this).wrap( "<div class='js-sub-menu-container'></div>" );
      var title = $(this).closest('.main-menu__item--parent').find('> .main-menu__link').html();
      $('<p class="main-menu__sub-menu__title desktop-only">' + title + '</p>').insertBefore($(this));


      let subMenu = $(this).closest('.js-sub-menu-wrapper');

      subMenu.sizer = function() {
        let textContent = subMenu.find('.js-sub-menu')
        let outerHeight = textContent.outerHeight(false)
        subMenu.css('--max-height-desktop', outerHeight+'px')
      }

      $(window).on('resize load orientationchange', subMenu.sizer)
      subMenu.sizer()
    });

    $('.main-menu__sub-menu--2').each(function() {
      $(this).wrap( "<div class='sub-menu-ruler'></div>" );
    });

    $('.header .main-menu > li > a').mouseenter(function() {
      if(!$.mlmi.mobile.isMobile){
        if(!$(this).hasClass('main-menu__item--selected')) {
          checkOpenMenus();
          $('body').removeClass('--search-open');
          $('.header .main-menu .main-menu__link').removeClass('main-menu__item--selected');
          $(this).addClass('main-menu__item--selected');
          $('body').addClass('--menu-is-opened');
        }
      }
    });

    $('.header__main-menu').mouseleave(function() {
      closeSubmenu();
      $('body').removeClass('--menu-is-opened');
      if ($('body').hasClass('search-page')) {
        $('body').addClass('--search-open')
      }
    });

    $('.js-close-main-menu').click(function() {
      closeSubmenu();
      $('body').removeClass('--menu-is-opened');
      if ($('body').hasClass('search-page')) {
        $('body').addClass('--search-open')
      }
    });

    function checkOpenMenus(){
      if($('body').hasClass('--search-open') || $('.main-menu__item--selected').length > 0 ){
        $('body').addClass('--menu-is-opened');
      }
    }

    function closeSubmenu(){
      $('.header .main-menu .main-menu__link').removeClass('main-menu__item--selected');
    }

    // Mobile menu animations
    $('.main-menu__sub-menu--1__link').click(function() {
      if($.mlmi.mobile.isMobile){
        event.preventDefault();
        $(this).closest('.main-menu__sub-menu--1__item').css('--max-height', $(this).closest('.main-menu__sub-menu--1__item').find('.main-menu__sub-menu--2').outerHeight() + 'px')
        $(this).closest('.main-menu__sub-menu--1__item').toggleClass('--submenu-open')
        // var list = $(this).next('ul');
        // if($(this).hasClass('--submenu-open')){
        //   $(this).removeClass('--submenu-open')
        //   var submenu_height = list.outerHeight();
        //   list.css('max-height', submenu_height+'px');
        //   setTimeout(function(){
        //     list.css('max-height', '');
        //   }, 10);
        // } else {
        //   $(this).addClass('--submenu-open')
        //   list.wrap( "<div class='sub-menu-ruler'></div>" );
        //   var submenu_height = list.outerHeight();
        //   list.unwrap();
        //   setTimeout(function(){
        //     list.css('max-height', submenu_height+'px');
        //     setTimeout(function(){
        //       list.css('max-height', 'none');
        //     }, 200);
        //   }, 10);
        // }
      }
    });

    //Search
    $('.js-search').on('click', function(e) {
      e.preventDefault();
      checkOpenMenus();
      closeSubmenu();
      $('body').toggleClass('--search-open');
      if(!$('body').hasClass('--search-open')){
        $('body').removeClass('--menu-is-opened');
      }
    });

    $('.js-close-search').click(function() {
      $('body').removeClass('--search-open');
      checkOpenMenus();
    });
  }
}
